import { getISOWeeksInYear } from "date-fns";

/**
 * 
 * @param {string} spaceVersion - A Layer0 release manifest version (e.g. "v202401.12.34", "test-123")
 * @description Checks whether spaceVersion matches standard format of `v<year><weeknumber>.<minor>.<patch>
 * @returns boolean
 */
export const isStandardFormat = (spaceVersion) => {
    if (!spaceVersion) {
      return false;
    }
    const decimalSplit = spaceVersion.split('.');
    if (decimalSplit.length !== 3) {
      return false; 
    }
    const [ major, minor, patch ] = decimalSplit;
    if (major.charAt(0) !== 'v') {
      return false;
    }
    if (major.length !== 7 || minor.length === 0 || patch.length === 0) {
      return false;
    }
    if (isNaN(Number(major.slice(1))) || isNaN(Number(minor)) || isNaN(Number(patch))) {
      return false;
    }
    return true;
};

/**
 * 
 * @param {string} spaceVersion - A Layer0 release manifest version (e.g. "v202401.12.34", "test-123")
 * @description Gets major version if spaceVersion is standard, returns null otherwise (e.g. "v202401.12.34" -> "v202401", "test-123" -> null)
 * @returns null | string
 */
export const getMajorSpaceVersion = (spaceVersion) => {
    if (!isStandardFormat(spaceVersion)) {
        return null;
    }
    return spaceVersion.split(".").shift();
};

/**
 * 
 * @param {*} spaceVersion A Layer0 release manifest version (e.g. "v202401.12.34", "test-123").
 * @description Calculates next major version of spaceVersion if spaceVersion is standard, returns null otherwise (e.g. "v202401.12.34" -> "v202402", "test-123" -> null)
 * @returns null | string
 */
export const calculateNextMajorVersion = (spaceVersion) => {
    if(!isStandardFormat(spaceVersion)) {
      return null;
    }
    const majorSpaceVersion = getMajorSpaceVersion(spaceVersion);
    const versionYear = Number(majorSpaceVersion.slice(1, 5));
    const versionWeek = Number(majorSpaceVersion.slice(5));
    const isoWeeksInYear = getISOWeeksInYear(new Date(`${versionYear}`));
    if (versionWeek === isoWeeksInYear) {
      return `v${versionYear + 1}01`;
    }
    const newWeek = String(versionWeek + 1).padStart(2, '0');
    return `v${versionYear}${newWeek}`;
};
